export type PeriodKey = "today" | "week" | "month" | "quarter" | "halfYear" | "year";

export type BudgetInterval = "day" | "week" | "month" | "quarter" | "half_year";

export interface DateRange {
  start_date: string;
  end_date: string;
}

export function formatISO(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function buildYearRange(year: number): DateRange {
  return {
    start_date: `${year}-01-01`,
    end_date: `${year}-12-31`,
  };
}

export function getCurrentYear(): number {
  return new Date().getFullYear();
}

export function getIntervalForPeriod(period: PeriodKey): BudgetInterval | undefined {
  switch (period) {
    case "today":
      return undefined;
    case "week":
    case "month":
      return "day";
    case "quarter":
    case "halfYear":
    case "year":
      return "month";
  }
}

export function computeInterval(startDate: string, endDate: string): BudgetInterval | undefined {
  const start = new Date(startDate);
  const end = new Date(endDate);
  const diffMs = end.getTime() - start.getTime();
  const diffDays = Math.round(diffMs / (1000 * 60 * 60 * 24));

  if (diffDays <= 14) return "day";
  if (diffDays <= 90) return "week";
  if (diffDays <= 730) return "month";
  return "quarter";
}

export function buildPeriodRange(period: PeriodKey): DateRange {
  const now = new Date();
  const today = formatISO(now);

  switch (period) {
    case "today":
      return { start_date: today, end_date: today };
    case "week": {
      const weekAgo = new Date(now);
      weekAgo.setDate(weekAgo.getDate() - 6);
      return { start_date: formatISO(weekAgo), end_date: today };
    }
    case "month": {
      const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
      return { start_date: formatISO(monthStart), end_date: today };
    }
    case "quarter": {
      const quarterStartMonth = Math.floor(now.getMonth() / 3) * 3;
      const quarterStart = new Date(now.getFullYear(), quarterStartMonth, 1);
      return { start_date: formatISO(quarterStart), end_date: today };
    }
    case "halfYear": {
      const halfYearStartMonth = now.getMonth() < 6 ? 0 : 6;
      const halfYearStart = new Date(now.getFullYear(), halfYearStartMonth, 1);
      return { start_date: formatISO(halfYearStart), end_date: today };
    }
    case "year":
      return buildYearRange(now.getFullYear());
  }
}

